import { computed, ref } from 'vue';
import { denomination } from 'config';

/**
 * * Transforms denomination
 */
const toOption = (n: number) => ({ id: n.toString(), text: `$${n}` });
const giftCardOptions = denomination.map(toOption);

export const useGiftBasic = () => {
  const selectedGift = ref<string | number>('');

  const giftOptions = computed(() => giftCardOptions);

  return {
    selectedGift,
    giftOptions,
  };
};
